import { Button } from 'antd';
import React from 'react';
import { useForm, withForm } from 'react-antd-formutil';
import HashLink from 'components/HashLink';
import modal from 'components/Modal';
import OnetimeCode from 'components/OnetimeCode';
import security from 'stores/security';
import './style.scss';

export interface TwoFactorAuthProps {
    close(q?): void;
    dismiss(q?): void;
}

const TwoFactorAuth: React.FC<TwoFactorAuthProps> = ({ close, dismiss }) => {
    const $formutil = useForm<{ code: string }>();

    const relogin = () => {
        // 该组件存在于两种情况下
        // 一是登录时候的二步验证(此时还未登录，不存在token)，二是关闭二步验证时的二步验证(登录态)
        if (security.isLogin) {
            security.logout();
        }

        window.location.href = '/login?loginType=email';
    };

    const submit = () => {
        close($formutil.$params.code);
    };

    const handleAlert = () => {
        modal
            .open({
                component: (
                    <>
                        <p>
                            {__(
                                'The one-time password is valid for 30 seconds. Please be sure that the password you entered is within the validity period.'
                            )}
                        </p>
                        <p>
                            {__(
                                'If you need to restore the TradeUP authenticator, please have your recovery QR code ready and scan the code from the authenticator.'
                            )}
                        </p>
                        <p>
                            {__(
                                'If you lose your recovery QR code, please contact the customer service at +1 (877) 212-0588 to disable the 2SV. (After disabling the 2SV, please'
                            )}
                            <HashLink onClick={relogin}> {__('re-login')}</HashLink>&nbsp;
                            {__('to the website for the changes to take effect.')})
                        </p>
                    </>
                ),
                closable: true
            })
            .result.catch(() => {});
    };

    return (
        <div>
            <h3>TradeUP Authenticator</h3>
            <p>{__('Please enter the 6-digit dynamic password displayed on the TradeUP Authenticator')}</p>
            <OnetimeCode
                name="code"
                checker={value => !!value || __('Please enter the 6-digit code')}
                $onFieldChange={(newValue, preValue) => newValue.length === 6 && newValue !== preValue && submit()}
            />
            <div className="verified-btn-container">
                <Button type="link" className="gray-btn" onClick={handleAlert}>
                    {__(`Can't be verified?`)}
                </Button>
            </div>
            <div className="btn-box">
                <Button type="default" onClick={() => dismiss(new Error(__('Dynamic passcode not entered')))}>
                    {__('Cancel')}
                </Button>
                <Button type="primary" disabled={$formutil.$invalid}>
                    {__('Confirm')}
                </Button>
            </div>
        </div>
    );
};

export default function require2FA() {
    return modal.open({
        className: 'modal-require-2fa',
        component: withForm(TwoFactorAuth)
    }).result;
}
